import {LogoBrand} from './LogoBrand.tsx';
import {ChipTone, type BankCardSkin} from './types.ts';

export const genericSkinBase: Omit<BankCardSkin, 'Face'> = {
    Brand: LogoBrand,
    chipTone: ChipTone.Gold,
    hasMastercard: false,
    surfaceTone: 'dark',
    contentColor: '#FFFFFF',
    labelColor: '#AAB0BB',
    contactlessColor: '#C9CCD3',
    mastercardWordColor: '#E6E8EC',
};
